<script>
    import kritikes from "../stores/kritikes";
    import geos from "../stores/geos";
    import {GEO_MATCHES} from "../lib/constants";
    import {kritikesImport, kritikesLoad, geosMatch} from "../lib/requests";
    import {
        scrollToElement,
        findUnmatched,
        expandParents,
        getParentNodes,
        collapseAll,
        searchNodes,
        findNode,
        backPath,
        findNodeParentOfLevel,
        upCaseStr
    } from "../lib/lib";
    import KritikesItem from "./KritikesItem.svelte";
    import app_alert from "../stores/alerts";
    import success from '../stores/success';
    import error from '../stores/error';

    let searchTerm
    let oldSearchTerm = '';
    let searchResults = [];
    let searchIndex = null;
    let unmatchedResults = [];
    let unmatchedIndex = null;
    let onRegionSearch = false;
    let oldSelectedId = 0;
    let selectedGeoParentPath = "";

    const onSearch = (event) => {
        if (event.key === 'Enter') {
            if (oldSearchTerm !== searchTerm) {
                resetSearch();
                if (searchTerm.length > 0) {

                    if (!isNaN(searchTerm)) {
                        // if search term is a location id
                        searchResults = [];
                        let node = findNode(searchTerm, $kritikes.tree);
                        if (node) {
                            searchResults.push(node.id);
                        }
                    } else {
                        // if search term is a string
                        let tree = $kritikes.tree;
                        if (onRegionSearch && $kritikes.selected_id > 0) {
                            // get node parent region
                            let region = findNodeParentOfLevel($kritikes.selected_id, 1, tree);
                            if (region) {
                                tree = region.children;
                            }
                        }

                        searchResults = searchNodes(upCaseStr(searchTerm), tree);
                    }

                    oldSearchTerm = searchTerm;
                }
                if (searchResults.length === 0) {
                    error.show("Δεν βρέθηκαν αποτελέσματα");
                } else {
                    $kritikes.last_selected_id = $kritikes.selected_id;
                }
            }
            showNextSearchResult();
        } else if (event.key === 'Escape') {
            searchTerm = '';
            resetSearch();
        }
    }

    const showNextSearchResult = () => {
        if (searchResults.length > 0) {
            if (searchIndex === null) {
                searchIndex = 0;
            } else {
                searchIndex++;
                if (searchIndex > searchResults.length - 1) {
                    searchIndex = 0;
                }
            }

            $kritikes.marked_id = searchResults[searchIndex];
            gotoLocation(searchResults[searchIndex]);
        }
    }

    const resetSearch = () => {
        oldSearchTerm = '';
        searchResults = [];
        searchIndex = null;
        $kritikes.marked_id = 0;
    }

    const onFindUnmatched = () => {
        unmatchedResults = findUnmatched($kritikes.matches, $kritikes.tree);
        unmatchedIndex = null;
    }

    const onShowNextUnmatched = () => {
        if (unmatchedIndex === null) {
            unmatchedIndex = 0;
        } else {
            unmatchedIndex++;
            if (unmatchedIndex > unmatchedResults.length - 1) {
                unmatchedIndex = 0;
            }
        }
        gotoLocation(unmatchedResults[unmatchedIndex]);
    }

    const onShowPreviusUnmatched = () => {
        if (unmatchedIndex === null) {
            unmatchedIndex = unmatchedResults.length - 1;
        } else {
            unmatchedIndex--;
            if (unmatchedIndex < 0) {
                unmatchedIndex = unmatchedResults.length - 1;
            }
        }
        gotoLocation(unmatchedResults[unmatchedIndex]);
    }

    const gotoLocation = (id, collapse_expanded = true) => {
        let node = findNode(id, $kritikes.tree);
        let parents = getParentNodes(node, $kritikes.tree);
        parents.map(item => {
            item.expanded = true;
        });
        $kritikes.selected_id = id;
        if (collapse_expanded) {
            onCollapseAll();
        }
        $kritikes.tree = $kritikes.tree;
        scrollToElement('kritikes-item-' + id);
    }

    const onCollapseAll = () => {
        collapseAll($kritikes.tree, $kritikes.selected_id);
        $kritikes.tree = $kritikes.tree;
        scrollToElement('kritikes-item-' + $kritikes.selected_id);
    }

    const onRefresh = () => {
        if ($kritikes.modified) {
            app_alert.show('confirm', "Να ανανεωθεί η λίστα των περιοχών;\nΟι αλλαγές που έκανες θα χαθούν!", Load);
            return;
        }
        Load();
    }

    const onMatchSelected = () => {
        if ($geos.selected_id === 0 || $kritikes.selected_id === 0) {
            app_alert.show('error', "Δεν έχετε επιλέξει περιοχή και στις δυο πλευρές!");
            return;
        }

        // check if location has been all ready matched with an other geo
        let match = $kritikes.matches.find(x => x.match_id === $kritikes.selected_id);

        if (match && match.geo_id !== $geos.selected_id) {
            let geoPath = backPath($geos.selected_id, $geos.tree);
            let locationPath = backPath(match.match_id, $kritikes.tree);
            app_alert.show(
                'confirm',
                `Η περιοχή<br><strong>${locationPath}</strong><br>έχει ήδη συσχετιστεί με το geo <br><strong>${geoPath}</strong><br>Θέλετε να αντικαταστήσετε αυτή την συσχέτιση;`,
                () => {
                    // remove old match
                    $kritikes.matches = $kritikes.matches.filter(x => x !== match);
                    let location = findNode(match.match_id, $kritikes.tree);
                    location.geo_matches = null; // set to null to refresh location matches

                    matchSelected();
                }
            );
            return;
        }

        matchSelected();
    }

    const matchSelected = () => {
        let match = $kritikes.matches.find(x => x.geo_id === $geos.selected_id && x.match_id === $kritikes.selected_id);
        // if (!match) {
        $kritikes.matches = [...$kritikes.matches, {geo_id: $geos.selected_id, match_id: $kritikes.selected_id}];
        // }

        // set node geo_id to null to refresh matched path
        let node = findNode($kritikes.selected_id, $kritikes.tree);
        node.geo_matches = null;

        node = findNode($geos.selected_id, $geos.tree);
        node.geo_matches = null;
        $geos.tree = $geos.tree;

        $kritikes.modified = true;
        success.show("Έγινε αντιστοίχιση");
    }

    const onMatchAllNodes = () => {
        if ($geos.selected_id === 0 || $kritikes.selected_id === 0) {
            app_alert.show('error', "Δεν έχετε επιλέξει περιοχή και στις δυο πλευρές!");
            return;
        }

        let location = findNode($kritikes.selected_id, $kritikes.tree);
        let geo = findNode($geos.selected_id, $geos.tree);
        let geoPath = backPath($geos.selected_id, $geos.tree);
        let locationPath = backPath($kritikes.selected_id, $kritikes.tree);
        app_alert.show(
            'confirm',
            `Να αντιστοιχιθεί τη περιοχή<br><strong>${locationPath}</strong><br>και όλες οι υποπεριοχές της με την<br><strong>${geoPath}</strong><br> από το Geos;`,
            () => matchAllNodes(geo, location)
        );
    }

    const matchAllNodes = (geo, location) => {
        let match = $kritikes.matches.find(x => x.geo_id === geo.id && x.match_id === location.id);
        if (!match) {
            $kritikes.matches = [...$kritikes.matches, {geo_id: geo.id, match_id: location.id}];
            geo.geo_matches = null;
            location.geo_matches = null;
        }
        geo.children.map(node => {
            matchAllNodes(node, location);
        });
    }

    const onUnMatchAllNodes = () => {
        if ($geos.selected_id === 0 || $kritikes.selected_id === 0) {
            app_alert.show('error', "Δεν έχετε επιλέξει περιοχή και στις δυο πλευρές!");
            return;
        }

        let location = findNode($kritikes.selected_id, $kritikes.tree);
        let geo = findNode($geos.selected_id, $geos.tree);
        let geoPath = backPath($geos.selected_id, $geos.tree);
        let locationPath = backPath($kritikes.selected_id, $kritikes.tree);
        app_alert.show(
            'confirm',
            `Να καταργηθεί αντιστοίχιση της περιοχής<br><strong>${locationPath}</strong><br>με όλες οι υποπεριοχές της με την<br><strong>${geoPath}</strong><br> από το Geos;`,
            () => unMatchAllNodes(geo, location)
        );
    }

    const unMatchAllNodes = (geo, location) => {
        let match = $kritikes.matches.find(x => x.geo_id === geo.id && x.match_id === location.id);
        if (match) {
            $kritikes.matches = $kritikes.matches.filter(x => x !== match);
            geo.geo_matches = null;
            location.geo_matches = null;
        }
        geo.children.map(node => {
            unMatchAllNodes(node, location);
        });
    }

    const onGotoLastSelected = () => {
        $kritikes.selected_id = $kritikes.last_selected_id;
        scrollToElement('kritikes-item-' + $kritikes.selected_id);
    }

    const toggleSearchScope = () => {
        onRegionSearch = !onRegionSearch;
        resetSearch();
    }

    const setLoadedData = (data) => {
        $kritikes.tree = data.tree;
        $kritikes.matches = data.matches;
        $kritikes.modified = false;
        $geos.match_source = GEO_MATCHES.KRITIKES_AGGELIES;

        if ($kritikes.selected_id === 0 && data.last_selected_id > 0) {
            $kritikes.selected_id = data.last_selected_id;
        }

        if ($kritikes.selected_id > 0) {
            expandParents($kritikes.selected_id, $kritikes.tree);
        }
    }

    const importFromServer = async () => {
        if (!window.confirm("Να γίνει εισαγωγή από τον server των Κρητικών Αγγελιών;")) {
            return;
        }

        const [err, res] = await kritikesImport();

        if (err) {
            alert('error ' + err)
            return;
        }

        setLoadedData(res);
    }

    const Load = async () => {

        const [err, res] = await kritikesLoad();

        if (err) {
            alert('error ' + err)
            return;
        }

        setLoadedData(res);
    }

    const Save = async () => {

        const [err, res] = await geosMatch(GEO_MATCHES.KRITIKES_AGGELIES, $kritikes.matches, $kritikes.selected_id, $geos.selected_id);
        if (err) {
            alert('error ' + err)
            return;
        }

        $kritikes.modified = false;
        success.show("Οι περιοχές ενημερώθηκαν.");
    }

    $geos.match_source = GEO_MATCHES.KRITIKES_AGGELIES;

    $:{
        if (oldSelectedId !== $kritikes.selected_id) {
            oldSelectedId = $kritikes.selected_id;
            selectedGeoParentPath = backPath($kritikes.selected_id, $kritikes.tree);
        }
        if ($kritikes.tree.length === 0) {
            Load();
        }
        if ($kritikes.search_term) {
            searchTerm = $kritikes.search_term;
            $kritikes.search_term = '';
            onSearch({key: 'Enter'});
        }
        if (!searchTerm && oldSearchTerm) {
            resetSearch();
        }
    }
</script>

<div class="section-header">
    <div class="row">
        <div class="col-md-8">
            <button class="btn btn-primary" on:click="{ onCollapseAll }" title="Κατάρευση όλων"><i
                    class="fa fa-toggle-up"></i></button>
            <span class="separator"></span>
            <button class="btn btn-primary" on:click="{ onMatchSelected }" title="Αντιστοίχιση με νέες περιοχές">
                <i class="fa fa-arrow-left"></i>
                <i class="fa fa-check"></i>
                <i class="fa fa-arrow-right"></i>
            </button>
            <button class="btn btn-primary" on:click="{ onMatchAllNodes }"
                    title="Αντιστοίχιση με όλες τις υπό περιοχές των Geos">
                <i class="fa fa-sitemap"></i>
                <i class="fa fa-check"></i>
                <i class="fa fa-arrow-right"></i>
            </button>
            <button class="btn btn-danger" on:click="{ onUnMatchAllNodes }"
                    title="Κατάργηση αντιστοίχισης με τις υπό περιοχές των Geos">
                <i class="fa fa-sitemap"></i>
                <i class="fa fa-check"></i>
                <i class="fa fa-remove"></i>
            </button>
            <span class="separator"></span>
            <button class="btn btn-primary" on:click="{ onFindUnmatched }" title="Εύρεση μη αντιστοιχισμένων">
                <i class="fa fa-chain-broken"></i>
                {#if unmatchedResults.length}
                    { unmatchedResults.length }
                {/if}
            </button>
            {#if unmatchedResults.length}
                <button class="btn btn-primary" on:click="{ onShowPreviusUnmatched }" title="Προηγούμενη περιοχή"><i
                        class="fa fa-arrow-left"></i></button>
                <button class="btn btn-primary" on:click="{ onShowNextUnmatched }" title="Επόμενη περιοχή"><i
                        class="fa fa-arrow-right"></i></button>
            {/if}
            <span class="separator"></span>
            <button class="btn btn-primary" on:click="{ onRefresh }" title="Ανανέωση περιοχών"><i
                    class="fa fa-refresh"></i></button>
            <button class="btn btn-primary" class:btn-primary={ !$kritikes.modified }
                    class:btn-danger={ $kritikes.modified } title="Αποθήκευση αλλαγών"
                    on:click="{ Save }"><i class="fa fa-save"></i></button>
            <span class="separator"></span>
            <button class="btn btn-primary" title="Εισαγωγή από τον server"
                    on:click="{ importFromServer }"><i class="fa fa-download"></i></button>
        </div>
        <div class="col-md-4">
            <div class="form-inline text-right">
                <button class="btn btn-primary" title="αναζήτηση στον νομό" on:click="{ toggleSearchScope }">
                    {#if onRegionSearch}
                        <i class="fa fa-map"></i>
                    {:else}
                        <i class="fa fa-map-o"></i>
                    {/if}
                </button>
                <input type="text" class="form-control" bind:value="{ searchTerm }" on:keyup="{ onSearch }"
                       placeholder="αναζήτηση">
                <button class="btn btn-primary" title="επιστροφή στην αρχική επιλογή" on:click="{ onGotoLastSelected }">
                    <i class="fa fa-arrow-left"></i></button>
            </div>
        </div>
    </div>
</div>

<div class="panel">
    <div class="panel-heading">
        <h2>Κρητικές Αγγελίες</h2>
        <h6>{ selectedGeoParentPath }</h6>
    </div>
    <div class="panel-body fixed-height">
        <div class="panel-body-inner">
            {#if $kritikes.tree && $kritikes.tree.length > 0}
                {#each $kritikes.tree as location}
                    <KritikesItem location="{ location }"/>
                {/each}
            {/if}
        </div>
    </div>
</div>